module.exports = __webpack_public_path__ + "img/avatar0.8aa70536.png";